<template>
<div class="chapter">
<div class="inner_page">
<div class="frame">
<p class="normal">Lily Girl’s</p>
<p class="normal1"><span class="char-style-override">Christmas Quilt</span><span class="char-style-override"></span></p>
<p class="normal">.............</p>
<img alt="Image" class="calibre1" src="CT_Logo.jpg"/>
</div>
<div class="basic-text-frame">
<p class="bodytext"><span class="testimonial-body"></span></p>
<p class="bodytext1"><span class="testimonial-body"></span></p>
</div>
<div class="basic-text-frame">
<p class="basic-paragraph"><span class="body-copy"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lily_Girl.vue?5d3bc798